export const FIELD_INFO = {
  'comms.pressReleasePdf': {
    title: 'קומוניקט PDF',
    text: 'הודעה לעיתונות בפורמט PDF מעוצב. המסמך יישלח כפי שהוא לאנשי מדיה — ודאו שהעיצוב, הפונטים והלוגואים נראים כמו שצריך.',
    file: { name: 'קומוניקט לדוגמה.pdf', url: 'themes/LNK/samples/press_release_sample.pdf' },
  },
  'comms.pressReleaseDoc': {
    title: 'קומוניקט Word',
    text: 'אותו תוכן כמו ה-PDF, בפורמט Word (.doc/.docx). אנשי מדיה מסוימים מעדיפים Word כדי לערוך ציטוטים ולהתאים לפורמט שלהם.',
    file: { name: 'קומוניקט לדוגמה.docx', url: 'themes/LNK/samples/press_release_sample.docx' },
  },
  'comms.lyrics': {
    title: 'מילות שירים',
    text: 'קובץ Word עם מילות כל השירים. יש לשמור על מבנה תצוגה של בתים ורווח בין בית לבית , (במקרה של אלבום כל השירים בדף אחד לפי סדר הופעתם באלבום.)',
    file: { name: 'מילות שירים לדוגמה.docx', url: 'themes/LNK/samples/lyrics_sample.docx' },
  },
  'comms.credits': {
    title: 'קרדיטים — קובץ',
    text: 'קובץ Word עם רשימת כל הקרדיטים: הפקה, עיבוד, מיקס, מאסטרינג, נגנים, כותבי מילים, מלחינים וכו\'.',
    file: { name: 'קרדיטים לדוגמה.docx', url: 'themes/LNK/samples/credits_sample.docx' },
  },
  'comms.creditsText': {
    title: 'קרדיטים — טקסט',
    text: 'בעמוד זה יופיע הקרדטים לתצוגה על הלינקטון עצמו, אפשר פשוט להעתיק מהקובץ קרדיטים ולהדביק בשדה',
    file: { name: 'קרדיטים טקסט לדוגמה.txt', url: 'themes/LNK/samples/credits_text_sample.txt' },
  },
  'comms.stickerText': {
    title: 'מדבקה — טקסט חופשי',
    text: 'טקסט שיופיע בחזית הלינקטון . בדרך כלל כולל ציטוט קצר, תיאור האלבום, או משפט שיווקי. מוגבל לכ-3 שורות.',
  },
  'tracks.audio': {
    title: 'קבצי אודיו',
    text: 'יש להעלות קובץ WAV (איכות מאסטר) או MP3 320kbps כקובץ מקור. מתוך קובץ המקור ניתן לייצר אוטומטית את הפורמטים הנוספים (MP3 128, MP2). קובץ MP2 נדרש לשידורי רדיו.',
  },
};
